import { IEmailFamily } from "./index";

export interface IEmailEntity {
    id: number;
    emailFamily: IEmailFamily;
    emailType: number;
    excelId: number;
}
